const url = '/crm-types';
const Provider = 'CrmTypes';
const dbModel = 'CrmTypes';

export { url, Provider, dbModel };
